import { NgFor } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-reviews',
  imports: [NgFor],
  templateUrl: './reviews.html',
  styleUrl: './reviews.css',
})
export class Reviews {
  readonly reasons = [
    {
      title: 'More Than Money',
      description:
        'We offer a partnership that includes technology, branding, and professional management systems.',
    },
    {
      title: 'Resource Synergy',
      description:
        'Benefit from the cross-pollination of ideas and resources across our diverse business units.',
    },
    {
      title: 'Built for Longevity',
      description:
        'We focus on creating sustainable assets that provide value for generations.',
    },
    {
      title: 'Execution Excellence',
      description:
        'Our history of managing complex holdings ensures your venture is built on a foundation of precision and integrity.',
    },
  ];
}
